module.exports = __webpack_public_path__ + "img/proapp-main.c283f9bc.jpg";